import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID, Renderer2, ElementRef, ViewChild, HostListener, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilder } from '@angular/forms';
import { CompanyService } from '../../services/company.service';
import { AppDataService } from '../../services/app-data.service';
import { CompanyBean } from '../../beansts/company.bean';
import { EventBean } from '../../beansts/Event';
import { TranslationService, WalletService } from '../../services';
import { MessagingService } from '../../messaging.service';
import { MenuConfigurationBean } from '../../beansts/menu.configuration.bean';
declare var Swiper: any;
declare var $ : any;

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'app-painel-aluno',
  templateUrl: './painel-aluno.component.html',
   styleUrls: ['./painel-aluno.component.css']
})
export class PainelAlunoComponent {
  videoTitle: string | null = null;
  room: string | null = null;
  selectedVideoSection: any;
  companyData: any;
  isModalOpen: boolean;
  menuConfig: MenuConfigurationBean;

  public event: EventBean=new EventBean();
  public buyerGold=0

  public photo='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Fbackgrounds%2Ftela%20fundo%20reuniao.jpeg?alt=media&token=2303f2d4-4b37-4531-aca0-c26b489a5465'
  public muted;


  public leave
  public navegarParaPainelAluno
  
  public endDate=''
  public startDate=''
  public queryRoom=null;
  public currentActivities=[]
  public nextActivities=[]
  public oldActivities=[]

  public hasCurrentActivities=false;
  public hasNextActivities=false;
  public hasOldActivities=false;

  public user={uid:'n/a',full_name:'Anonimo',profile_picture:'nil'};


  public companyEvents:EventBean [];
  public company:CompanyBean=new CompanyBean();
  router: any;

  constructor(    private renderer: Renderer2,
    private route: ActivatedRoute,
    private _companyService: CompanyService,
    private _router: Router,
    public _appData: AppDataService,
    public _routeParams : ActivatedRoute,     @Inject(PLATFORM_ID) private platformId: Object,
  ) {}
  ngOnInit(): void {
    const h3Element = document.querySelector('.video-text');
    if (h3Element) {
        h3Element.setAttribute(
            'style',
            'font-size: 16px; line-height: 20px; color: black !important;'
        );
    }
    this._routeParams.queryParams.subscribe(params => {
      var companyId = params.id;

      this._companyService.getLandingCompany(companyId).get().then(doc => {
        let main = document.getElementById("main");
        main.style.removeProperty("overflow");

        if (doc.exists) {
          this.companyData = doc.data();
          this._appData.gameUrl = "/gamephoto.html?room=" + this.companyData.room;
        } else {
          console.error("Documento não encontrado");
        }
      }).catch(error => {
        console.error("Erro ao obter dados da empresa:", error);      });
    });


  }
  public navigateToGame() {
    let game=document.getElementById('gameFrame')
    game.style.visibility='visible';
    let main3=document.getElementById('main4')
    main3.remove();
    let main = document.getElementById("main");
    main.style.overflow='hidden';

    //    this._router.navigate(['gameevent',1592880902713],{ queryParams: {room: this.companyData.room}})
  }
  isSidebarOpen = true; // Inicialmente, a sidebar está visível

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen; // Alterna o estado da sidebar
  }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/painel-aluno/painel-aluno.component.ts